import { useTranslation } from "react-i18next";
import { Sliders, Building2, ShieldCheck, LifeBuoy, AlertTriangle } from "lucide-react";
import { AppShell } from "../components/layout/AppShell";
import { useAuth } from "../context/AuthContext";
import { isAdmin, isCompanyAdmin } from "../utils/role";
import { useFeatures } from "../hooks/useFeatures";
import { SettingsSection } from "../components/settings/SettingsSection";
import { ProfileCard } from "../features/settings/ProfileCard";
import { PreferencesCard } from "../features/settings/PreferencesCard";
import { SessionCard } from "../features/settings/SessionCard";
import { PasswordForm } from "../features/settings/PasswordForm";
import { CurrencySettings } from "../features/settings/CurrencySettings";
import { AvailableFeatures } from "../features/settings/AvailableFeatures";
import { DeleteAccountCard } from "../features/settings/DeleteAccountCard";
import { MyDataExportCard } from "../features/settings/MyDataExportCard";
import { ConsentsCard } from "../features/settings/ConsentsCard";
import { SupportCard } from "../features/settings/SupportCard";
import { BuildStamp } from "../features/settings/BuildStamp";

export default function SettingsPage() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const features = useFeatures();
  const isManager = isAdmin(user);
  const showCurrencies = isManager && features.fx_rates;
  const showFeatures = isManager && features.service_requests;
  const hasCompany = showCurrencies || showFeatures;

  return (
    <AppShell title={t("settings.title")}>
      <div className="settings-zoom mx-auto w-full max-w-3xl space-y-6 sm:space-y-8">
        <SettingsSection testId="section-account">
          <ProfileCard />
        </SettingsSection>

        <SettingsSection icon={Sliders} title={t("settings.sections.preferences")} testId="section-preferences">
          <PreferencesCard />
        </SettingsSection>

        <SettingsSection testId="section-password">
          <PasswordForm />
        </SettingsSection>

        {hasCompany ? (
          <SettingsSection icon={Building2} title={t("settings.sections.company")} testId="section-company">
            {showCurrencies ? <CurrencySettings /> : null}
            {showFeatures ? <AvailableFeatures /> : null}
          </SettingsSection>
        ) : null}

        <SettingsSection icon={ShieldCheck} title={t("settings.sections.privacy")} testId="section-privacy">
          {isManager ? <MyDataExportCard /> : null}
          <ConsentsCard />
        </SettingsSection>

        {isManager ? (
          <SettingsSection icon={LifeBuoy} title={t("settings.sections.support")} testId="section-support">
            <SupportCard />
          </SettingsSection>
        ) : null}

        <SettingsSection icon={AlertTriangle} title={t("settings.sections.danger")} testId="section-danger">
          <SessionCard />
          {isCompanyAdmin(user) ? <DeleteAccountCard /> : null}
        </SettingsSection>
      </div>
      <BuildStamp />
    </AppShell>
  );
}
